import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/site";
import { useLang } from "@/lib/i18n";

const CONTACT_EMAIL = "code.echo.first.aid@gmail.com";

export default function Footer() {
  const { t, logo } = useLang();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0B0C10] py-20">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 text-center">
        <Reveal>
          <img
            src={logo}
            alt="Code Echo First Aid"
            className="mx-auto h-12 w-auto mb-10 cursor-pointer"
            onClick={() => scrollToId("top")}
          />
          <p className="text-sm leading-relaxed text-zinc-300 max-w-2xl mx-auto">
            {t.foot_disclaimer}
          </p>

          <p
            data-testid="footer-inquiry"
            className="mt-10 text-sm sm:text-base text-zinc-200"
          >
            {t.foot_inquiry_prefix}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-inquiry-email"
              className="text-[#4d9fff] underline underline-offset-4 decoration-white/20 hover:text-white transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
            {t.foot_inquiry_suffix}
          </p>

          <div className="mt-12 h-px w-full bg-white/10" />
          <p className="mt-8 text-xs tracking-wide text-zinc-400">
            {t.copyright}
          </p>
        </Reveal>
      </div>
    </footer>
  );
}
